import { UIHeading4, UIText1 } from '@cian/ui-kit/typography';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IProps {
  className?: string;
  title: string;
  rating: string;
  fillPercent?: number;
}

export function ReviewsBar({ className, title, rating, fillPercent }: IProps) {
  const fillWidth = Number(fillPercent) ? `${fillPercent}%` : 0;

  return (
    <div className={cx(styles['wrapper'], className)}>
      <div className={styles['title']}>
        <UIHeading4>{title}</UIHeading4>
      </div>
      <div className={styles['bar-rating']}>
        <div className={styles['bar']}>
          <div className={styles['bar-filler']} style={{ width: fillWidth }} />
        </div>
        <div className={styles['rating']}>
          <UIText1>{rating}</UIText1>
        </div>
      </div>
    </div>
  );
}
